<template>
  <div class="footer" id="footer">

	<div class="container-fluid">
		<div class="row">
			 
			<div class="col col-lg-12 col-md-12 col-sm-12 col-12">
				<div class="sub-footer-copyright">
					<span>
						Copyright <router-link to="#">info@matchdaydeals.com</router-link> All Rights Reserved {{year}}
					</span>
				</div>
			</div>
		</div>
	</div>
</div>

</template>

<script>
export default {
    name: "Footer",
    data() {
        return {
            projectName: "",
            year: ''
        }
    },
    mounted() {
        this.year = new Date().getFullYear();
        this.projectName = this.$store.state.projectName;
    },
}
</script>

<style>
.footer {
	padding: 0;
}
.sub-footer-copyright {
	margin-top: 0;
	border:none;
}
</style>